import { getTenantId } from 'common/helpers/apiHelper';

const NHVinoMessage = (props) => {
  const { clubPackage } = props;
  if (getTenantId() !== 'newsome-harlow-wines') {
    return null;
  }
  if (clubPackage.clubId === '7f817796-fa9a-4a21-a3f9-aa9929f714f5') {
    return (
      <ul>
        <li>
          Your Club Cart must contain a minimum of 6 items at all times. If you
          are exchanging wines please remember to add wines to your Club Cart
          before removing the wines you are exchanging. This will allow you to
          remain at 6 wines minimum.
        </li>
      </ul>
    );
  }
  if (
    clubPackage.clubId === '94e3c871-4570-4957-b4ba-c55196e24bde' ||
    clubPackage.clubId === '3627678c-4e32-424a-a1a9-998dd4766424' ||
    clubPackage.clubId === '23f0edae-17b7-472f-bc7f-1cbcb53834c9' ||
    clubPackage.clubId === 'b806e8a8-964d-4df0-9c5f-90230c540994'
  ) {
    return (
      <ul>
        <li>
          Your Club Cart must contain a minimum of 6 items at all times. If you
          are exchanging wines please remember to add wines to your Club Cart
          before removing the wines you are exchanging. This will allow you to
          remain at 6 wines minimum.
        </li>
      </ul>
    );
  }
  if (clubPackage.clubId === '8d1dccdf-f3a7-4abd-b050-0d5d1ad3fe4a') {
    return (
      <ul>
        <li>
          Your Club Cart must contain a minimum of 3 items at all times. If you
          are exchanging wines please remember to add wines to Club Cart before
          removing the wines you are exchanging. This will allow you to remain
          at 3 wines minimum
        </li>
      </ul>
    );
  }
  if (clubPackage.clubId === '51c0d2c6-8ba3-47a8-bbda-6f309726e978') {
    return (
      <ol>
        <li>
          Your Club Cart must contain a minimum of 12 items at all times. If you
          are exchanging wines please remember to add wines to Club Cart before
          removing the wines you are exchanging. This will allow you to remain
          at 12 wines minimum.
        </li>
        <li>As a Twelve Bottle Club member, your shipping fees are ON US!</li>
      </ol>
    );
  }
  return null;
};

export default NHVinoMessage;
